import EventDispather from './eventDispather';
export default class EventEmitter {
    constructor() {
        this.event = new EventDispather();
    }
    on(eventName, fn){
        this.event.addEventListener(eventName, fn)
    }
    off(eventName, fn){
        this.event.removeEventListener(eventName, fn)
    }
    emit(eventName, data){
        this.event.dispatchEvent(eventName, data)
    }
    once(eventName, fn){
        let callback = (data) => {
            this.event.removeEventListener(eventName, callback);
            fn(data)
        }
        this.event.addEventListener(eventName, callback)
    }
    removeAll(eventName){
        this.event.removeAllEventListener(eventName)
    }
}